export const Theme = {
  primary: {
    main: '#6935FD'
  },
  text: {
    black: '#000000',
    gray: '#616161',
    light_gray: '#A8A8A8'
  }
}
